import isMobile from 'ismobilejs';
import Store from "./Store.js";

export default class Device {
  constructor() {
    this.store = new Store();
  }
  
  isMobile() {
    return isMobile(window.navigator).any;
  }

  isMobileApp() {
    return this.store.get("isMobileApp");
  }

  setMobileApp(isMobileApp) {
    this.store.set("isMobileApp", isMobileApp);
  }
}
